module.exports = __webpack_public_path__ + "static/media/compass.9697e23d.png";